export function zoomPower(value: number, base: number): number {
  return Math.pow(base, Math.floor(Math.round((Math.log(value) / Math.log(base)) * 100) / 100))
}
